import { AppGatsbyImageFluid } from '../primitives/appImage';
import { graphql, useStaticQuery } from 'gatsby';
import { mapValues } from 'lodash';
import { getFluidImage } from '../appGatsbyImageUtils';
import { PrestationMainImagesQuery } from '../appGraphQLTypes';
import { useMemo } from 'react';
import { PrestationName } from '../appConstants';

type PrestationMainImages = { [key in PrestationName]: AppGatsbyImageFluid };

const usePrestationMainImages = (): PrestationMainImages => {
  const data = useStaticQuery<PrestationMainImagesQuery>(graphql`
    fragment PrestationMainImage on File {
      ...AppFluidHeroImageFragment
    }

    query PrestationMainImages {
      photo: file(relativePath: { eq: "prestation_photo-header-v2.jpg" }) {
        ...PrestationMainImage
      }
      video: file(relativePath: { eq: "prestation_video_header.jpg" }) {
        ...PrestationMainImage
      }
      matterport: file(
        relativePath: { eq: "prestation_matterport-avantages-header.jpg" }
      ) {
        ...PrestationMainImage
      }
      drone: file(relativePath: { eq: "prestation_drone_header.jpg" }) {
        ...PrestationMainImage
      }
    }
  `);
  return useMemo(() => {
    return mapValues(data, (file, key) =>
      getFluidImage(file as any, key + ' first image not found'),
    );
  }, [data]);
};

export default usePrestationMainImages;
